export default __webpack_public_path__ + "static/media/cello-image.006ca438.png";